import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "./Rbac.module.css";
import { IconButton } from "@mui/material";
import { AddCircleRounded, RemoveCircleRounded } from "@mui/icons-material";
import { AxiosInstance } from "../../../axios/index";
import Loader from "../../../shared/Component/Loader";
import { employeeRoutes } from "../../../AppConfig";

const ViewPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedRole = location?.state?.selectedRole;
  const { user_id } = useParams();
  const { EmpType, Location, Search } = location.state || {};
  const [basicDetails, setBasicDetails] = useState({});
  const [pageDetails, setPageDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [expandedModules, setExpandedModules] = useState({});
  const normalizeModuleName = (name) => {
    switch (name) {
      case "Admission":
        return "Admission List";
      default:
        return name;
    }
  };
  const moduleOrder = {
    "Admission List": 1,
    Batch: 2,
    Faculty: 3,
    "Test List": 4,
    "Registered Users": 5,
    "Course Management": 6,
    Announcements: 7,
    "Coupon Code": 8,
    "Study Materials": 9,
    Gallery: 10,
    "Faculty Profile": 11,
    "Exam Centers": 12,
    "Student List": 13,
    "Students Query": 14,
    "Cash Payments": 15,
    "Panel List": 16
  };
  const handleToggleExpand = (module) => {
    setExpandedModules((prev) => ({
      ...prev,
      [module]: !prev[module],
    }));
  };
  const handleBackFilter = () => {
    navigate(`/roleList`, {
      state: {
        filter_emptype: EmpType,
        filter_location: Location,
        filter_search: Search,
      },
    });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      if (!user_id) return;
      try {
        setIsLoading(true);
        const response = await AxiosInstance.post("/api/menu/findById", {
          user_id,
        });
        const data = response?.data?.data;

        if (data) {
          const basic = data?.basicDetails?.[0] || {};
          setBasicDetails(basic);
          // Merge all menu_ids
          const mergedIds = [
            ...new Set(
              data.pageDetails
                ?.map((p) => p.menu_id?.split(","))
                .flat()
                .filter(Boolean)
            ),
          ];

          const { title, description } = data.pageDetails?.[0] || {};
          const formattedMenu = mergedIds
            .map((id) => {
              const found = employeeRoutes.find(
                (route) => String(route.id) === String(id)
              );
              return found
                ? {
                  id,
                  module: normalizeModuleName(found.module || "-"),
                  page: found.page || found.path || "-",
                  order: parseInt(found.order) || 999,
                }
                : null;
            })
            .filter(Boolean);
          const grouped = formattedMenu.reduce((acc, curr) => {
            if (!acc[curr.module]) acc[curr.module] = [];
            acc[curr.module].push(curr);
            return acc;
          }, {});
          const sortedGrouped = Object.fromEntries(
            Object.entries(grouped).sort(([a], [b]) => {
              const orderA = moduleOrder[a] || 999;
              const orderB = moduleOrder[b] || 999;
              return orderA - orderB;
            })
          );
          // Expand all
          const initialExpanded = Object.keys(sortedGrouped).reduce(
            (acc, mod) => {
              acc[mod] = true;
              return acc;
            },
            {}
          );
          setExpandedModules(initialExpanded);
          setPageDetails({
            title,
            description,
            menus: sortedGrouped,
          });
        } else {
          setBasicDetails({});
          setPageDetails(null);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [user_id]);

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      <Loader />
    </div>
  ) : (
    <div className="container-fluid global_container p-0">
      <div className={`${styles.cm_container} BathHeader`}>
        {/* HEADER */}
        <div className="row">
          <div className="col-md-6 col-12">
            <h2 className="TitleHeader">View Page Access</h2>
          </div>
          <div className="col-md-6 col-12 ListBtn">
            <ul className="List-Button">
              <li className="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  onClick={handleBackFilter}
                  className="secondaryButton"
                >
                  Back to Page Access
                </Link>
              </li>
              <li className="ListBtnItems">
                <Link
                  to={`/EditPageAccess/${user_id}`}
                  state={{ selectedRole }}
                  className="primaryButton"
                >
                  <span className="material-icons me-1 fs-5 align-middle text-white">
                    border_color
                  </span>
                  Edit Page Access
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* EMPLOYEE DETAILS */}
        <div className="row p-2 py-0">
          <fieldset className="mt-3">
            <legend className="w-auto">Employee Details</legend>
            <div className="row mb-3">
              {[
                ["Name", basicDetails?.fullname],
                ["Employee_ID", basicDetails?.faculty_id],
                ["Email", basicDetails?.email],
                ["Phone Number", basicDetails?.mobile_no],
                ["Employee Type", basicDetails?.emp_type],
                ["Location", basicDetails?.location],
              ].map(([label, value], i) => (
                <div key={i} className="my-1 col-lg-3 col-md-3 col-12">
                  <p className="confirm_label m-0 p-0">{label}</p>
                  <p className="confirm_value my-1 m-0 p-0">{value || "_"}</p>
                </div>
              ))}
            </div>
          </fieldset>

          {/* TITLE SECTION */}
          {pageDetails && (
            <fieldset className="mt-4">
              <legend className="w-auto">Title</legend>
              <div className="row mb-2">
                <div className="col-md-6">
                  <p className="confirm_label m-0 p-0">Title</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {pageDetails?.title || "_"}
                  </p>
                </div>
                <div className="col-md-6">
                  <p className="confirm_label m-0 p-0">Description</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {pageDetails?.description || "_"}
                  </p>
                </div>
              </div>
            </fieldset>
          )}

          {/* TABLE */}
          {pageDetails ? (
            <fieldset className="mt-4">
              <legend className="w-auto">Page Access Details</legend>

              <div className="col-md-12 table-responsive tableMinHeight p-0">
                <table className="table" id="tableListHeader">
                  <thead className={styles.permission_column}>
                    <tr>
                      <th>S.No</th>
                      <th>Module</th>
                      <th>Pages</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(pageDetails?.menus || {}).map(
                      ([module, pages], moduleIndex) => (
                        <React.Fragment key={module}>
                          {/* MODULE ROW */}
                          <tr>
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <IconButton
                                  size="small"
                                  disableRipple
                                  onClick={() => handleToggleExpand(module)}
                                  style={{
                                    color: "#808080",
                                    padding: "4px",
                                    marginRight: "6px",
                                  }}
                                >
                                  {expandedModules[module] ? (
                                    <RemoveCircleRounded fontSize="small" />
                                  ) : (
                                    <AddCircleRounded fontSize="small" />
                                  )}
                                </IconButton>
                                {moduleIndex + 1}
                              </div>
                            </td>
                            <td>{module}</td>
                            <td>-</td>
                          </tr>

                          {/* SUB-PAGES SORTED */}
                          {expandedModules[module] &&
                            [...pages]
                              .sort((a, b) => a.order - b.order)
                              .map((pageItem) => (
                                <tr key={pageItem.id}>
                                  <td></td>
                                  <td>{pageItem.module}</td>
                                  <td>{pageItem.page}</td>
                                </tr>
                              ))}
                        </React.Fragment>
                      )
                    )}

                    {Object.keys(pageDetails?.menus || {}).length === 0 && (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </fieldset>
          ) : (
            !isLoading && (
              <div className="text-center mt-4">No Page Access Details</div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewPage;
